import React from 'react';

const SkipLink = () => (
  <a href="#main-content" className="skip-link" data-testid="skip-to-content-link">
    Aller au contenu principal
  </a>
);

export default SkipLink;
